import { CandidateData } from '../../../../types/candidates';

const filterByYearsOfExperience = (
  singleCandidate: CandidateData,
  searchedYear: number
) => {
  return (
    singleCandidate.YearsOfExperience &&
    singleCandidate.YearsOfExperience >= searchedYear
  );
};

export default filterByYearsOfExperience;
